import { render } from "./MobileAppShell.vue?vue&type=template&id=b7492bba&scoped=true"
import script from "./MobileAppShell.vue?vue&type=script&lang=js"
export * from "./MobileAppShell.vue?vue&type=script&lang=js"

import "./MobileAppShell.vue?vue&type=style&index=0&id=b7492bba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7492bba"]])

export default __exports__